import { render, staticRenderFns } from "./ThreadOpen.vue?vue&type=template&id=c592b888"
import script from "./ThreadOpen.vue?vue&type=script&lang=js"
export * from "./ThreadOpen.vue?vue&type=script&lang=js"
import style0 from "./ThreadOpen.vue?vue&type=style&index=0&id=c592b888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports